import { useEffect, useRef } from 'react';
import { getFrameType } from '../utils/frameUtils';
import { createAnimator } from '../utils/animators';

export const useAvatarAnimation = (withFrame, user, frameType, avatarRef) => {
  const animationRef = useRef(null);

  useEffect(() => {
    // Останавливаем предыдущую анимацию
    if (animationRef.current) {
      cancelAnimationFrame(animationRef.current);
      animationRef.current = null;
    }

    // Сбрасываем стили
    if (avatarRef.current) {
      avatarRef.current.style.boxShadow = '';
      avatarRef.current.style.borderColor = '';
      avatarRef.current.style.borderWidth = '';
    }

    // Запускаем новую анимацию если нужно
    if (!withFrame || !avatarRef.current) return;

    const currentFrameType = getFrameType(user, frameType);
    if (!currentFrameType) return;

    const startAnimation = createAnimator(avatarRef, animationRef);
    startAnimation(currentFrameType);

    return () => {
      if (animationRef.current) {
        cancelAnimationFrame(animationRef.current);
        animationRef.current = null;
      }
    };
  }, [withFrame, user?.id, user?.is_superuser, user?.is_staff,
      user?.is_librarian, user?.is_donor, frameType]);
};